import { render, staticRenderFns } from "./questionAnalysis.vue?vue&type=template&id=0b08970c&scoped=true&"
import script from "./questionAnalysis.vue?vue&type=script&lang=js&"
export * from "./questionAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./questionAnalysis.vue?vue&type=style&index=0&id=0b08970c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b08970c",
  null
  
)

export default component.exports